import { Component, HostBinding, signal, OnChanges, SimpleChanges } from '@angular/core';
import { ResponsiveSetting } from 'shared/responsive-settings/responsive-settings.interface';

import { SliceBaseRenderComponent } from 'extensions/core/slice-base/render/slice-base-render.component';


@Component({
  selector: 'slice-ab-testing-render',
  templateUrl: './slice-ab-testing-render.component.html',
  styleUrls: ['./slice-ab-testing-render.component.scss']
})
export class SliceAbTestingRenderComponent extends SliceBaseRenderComponent implements OnChanges {

  @HostBinding('class.hidden')
  public get display(): boolean {
    return this.slots.filter((slot) => !slot.hidden).length === 0;
  }

  @HostBinding('attr.data-composition-id')
  public get compositionId(): string | undefined {
    const compositionId = this.slice.settings?.general.compositionId;
    return compositionId !== '' ? compositionId : undefined;
  }

  @HostBinding('style.opacity')
  public get opacity(): number {
    const opacity = this.slice.settings?.styles.opacity;
    return opacity && opacity !== '' ? opacity / 100 : 1;
  }

  public readonly activeSlot = signal<number>(0);

  public get activeSlotSettings() {
    return this.slots?.[this.activeSlot()] ?? null;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.slice && this.slice.settings?.general) {
      const percentageA = this.slice.settings.general.percentageA ?? 50;
      const random = Math.random() * 100;
      const selectedSlot = random < percentageA ? 0 : 1;
      this.activeSlot.set(selectedSlot);
    }
  }

  protected onSliceInit(): void { /* empty */ }

  protected setDefaultHostStyles(): void {
    this.backgroundColor = this.slice.settings?.styles.bgColor || '';
    this.marginTop = this.slice.settings?.styles.marginTop || '';
    this.marginRight = this.slice.settings?.styles.marginRight || '';
    this.marginLeft = this.slice.settings?.styles.marginLeft || '';
    this.marginBottom = this.slice.settings?.styles.marginBottom || '';
    this.paddingTop = this.slice.settings?.styles.paddingTop || '';
    this.paddingRight = this.slice.settings?.styles.paddingRight || '';
    this.paddingLeft = this.slice.settings?.styles.paddingLeft || '';
    this.paddingBottom = this.slice.settings?.styles.paddingBottom || '';
  }

  protected setResponsiveHostStyles(
    breakpointStyles: ResponsiveSetting,
    defaultBpSettings: Partial<ResponsiveSetting>
  ): void {
    this.backgroundColor = this.slice.settings?.styles.bgColor || '';
    this.marginTop = breakpointStyles.marginTop || defaultBpSettings.marginTop || '';
    this.marginRight = breakpointStyles.marginRight || defaultBpSettings.marginRight || '';
    this.marginLeft = breakpointStyles.marginLeft || defaultBpSettings.marginLeft || '';
    this.marginBottom = breakpointStyles.marginBottom || defaultBpSettings.marginBottom || '';
    this.paddingTop = breakpointStyles.paddingTop || defaultBpSettings.paddingTop || '';
    this.paddingRight = breakpointStyles.paddingRight || defaultBpSettings.paddingRight || '';
    this.paddingLeft = breakpointStyles.paddingLeft || defaultBpSettings.paddingLeft || '';
    this.paddingBottom = breakpointStyles.paddingBottom || defaultBpSettings.paddingBottom || '';
  }

}
